/** Surface container. Colour comes only from tokens (CLAUDE.md 14.2). */
import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/lib/cn'

export function Card({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('rounded-lg border border-border bg-surface', className)} {...props} />
}

export function CardHeader({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('border-b border-border px-4 py-3', className)} {...props} />
}

export function CardTitle({ className, ...props }: ComponentPropsWithoutRef<'h3'>) {
  // The rule cannot see children arriving through a spread, so it assumes the
  // heading is empty. Every call site passes text; this is a wrapper, not a heading
  // with no content.
  // eslint-disable-next-line jsx-a11y/heading-has-content
  return <h3 className={cn('text-sm font-semibold', className)} {...props} />
}

export function CardBody({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('p-4', className)} {...props} />
}

export function CardFooter({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('border-t border-border px-4 py-3', className)} {...props} />
}
